import {bootstrapApplication} from '@angular/platform-browser';
import {appConfig} from './app/app.config';
import {AppComponent} from './app/app.component';
import * as Sentry from '@sentry/angular';
import {environment} from './environments/environment';

Sentry.init({
  dsn: 'https://8f2cc39577bd20b911d9cfb7b7c63766@o4508122469564416.ingest.de.sentry.io/4508122478936144',
  integrations: [Sentry.browserTracingIntegration()],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  tracePropagationTargets: [
    'https://patja.wf.mk',
    'https://patja-staging.wf.mk',
    'https://patja-prod.wf.mk',
  ],
  enabled: environment.production,
});

bootstrapApplication(AppComponent, appConfig).catch();
